import { DataBean } from "../DataBean";

export class FinancialTax extends DataBean {



    public async getFinancialTaxSchemeCatalog(id: any,): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getFinancialTaxSchemeCatalog_Number", [id]);
    }

}